import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class reportFilterPanel.
 *
 */
import PropTypes from 'prop-types';
import { Button, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import React, { Component } from 'react';
import entityComposition from '../common/classes/entityComposition';
import FullTextInstructions from '../common/search/fullTextInstructions';
import Icon from '../common/containers/icon';
import ReportFilters from './reportFilters';
import SavedReportFilters from './savedReportFilters';
import SearchInput from '../common/search/searchInput';
class ReportFilterPanel extends Component {
  constructor(props) {
    super(props);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handleTextFilterChange = this.handleTextFilterChange.bind(this);
    this.handleTextFilterClear = this.handleTextFilterChange.bind(this, '');
    this.handleMetaDeletedChange = this.handleMetaDeletedChange.bind(this);
  }
  handleMetaDeletedChange(value) {
    const _this$props = this.props,
      reportIndexQuery = _this$props.reportIndexQuery,
      reportActions = _this$props.reportActions;
    const newFilters = _objectSpread(_objectSpread({}, reportIndexQuery.filters), {}, {
      metaDeleted: value
    });
    reportActions.serverFilter(newFilters, reportIndexQuery);
  }
  handleClearAll() {
    const _this$props2 = this.props,
      reportActions = _this$props2.reportActions,
      reportIndexQuery = _this$props2.reportIndexQuery,
      reportInitialIndexQuery = _this$props2.reportInitialIndexQuery;

    // Reset metaDeleted to 0 (default) explicitly
    const newFilters = _objectSpread(_objectSpread({}, reportInitialIndexQuery.filters), {}, {
      metaDeleted: 0
    });
    reportActions.serverFilter(newFilters, reportIndexQuery);
    const filterEntities = ['assetFilterReport', 'creatorFilterReport', 'reportAssignmentFilterReport', 'currentStateFilterReport', 'issueSeverityFilterReport', 'jobAndPhaseCodeFilterReport', 'jobPieceFilterReport', 'orgFilterReport', 'reportTagFilterReport', 'reportTypeFilterReport', 'statusFilterReport'];
    filterEntities.forEach(entity => {
      /* eslint-disable react/destructuring-assignment */
      const entityIndexQuery = this.props["".concat(entity, "IndexQuery")];
      // no need to reset filters that have not yet been loaded
      if (entityIndexQuery.initialized) {
        const entityInitialIndexQuery = this.props["".concat(entity, "InitialIndexQuery")];
        const actions = this.props["".concat(entity, "Actions")];
        actions.serverIndex(entityInitialIndexQuery);
      }
      /* eslint-enable react/destructuring-assignment */
    });

    // clear the text search
    this.handleTextFilterClear();
  }
  handleTextFilterChange(textValue) {
    // sometimes this is called with null, which can be ignored. The search box can be cleared with
    // an empty string
    if (textValue === null) return;
    const _this$props3 = this.props,
      reportIndexQuery = _this$props3.reportIndexQuery,
      reportActions = _this$props3.reportActions;
    const newFilters = _objectSpread(_objectSpread({}, reportIndexQuery.filters), {}, {
      text: textValue
    });
    reportActions.serverFilter(newFilters, reportIndexQuery);
  }
  render() {
    const _this$props4 = this.props,
      reportIndexQuery = _this$props4.reportIndexQuery,
      reportFilter = _this$props4.reportFilter,
      reportFilterActions = _this$props4.reportFilterActions,
      reportActions = _this$props4.reportActions,
      userID = _this$props4.userID,
      username = _this$props4.username;
    const searchLabel = /*#__PURE__*/React.createElement(FullTextInstructions, null);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, /*#__PURE__*/React.createElement("h3", {
      className: "t-rfp-title"
    }, "Filter")), /*#__PURE__*/React.createElement(Col, {
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleClearAll,
      className: "float-md-right t-rfp-clear"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "times-circle",
      weight: "far"
    }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
      type: "text",
      label: searchLabel,
      text: reportIndexQuery.filters.text,
      onChange: this.handleTextFilterChange,
      onClear: this.handleTextFilterClear
    }), /*#__PURE__*/React.createElement(ReportFilters, {
      username: username,
      onMetaDeletedChange: this.handleMetaDeletedChange
    }))), /*#__PURE__*/React.createElement(Card, {
      className: "filters"
    }, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement("h3", null, "Saved Filters")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SavedReportFilters, {
      id: "saved-filters",
      reportFilter: reportFilter,
      reportFilterActions: reportFilterActions,
      reportIndexQuery: reportIndexQuery,
      reportActions: reportActions,
      userID: userID
    }))));
  }
}
ReportFilterPanel.propTypes = {
  reportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      text: PropTypes.string,
      metaDeleted: PropTypes.number
    })
  }).isRequired,
  reportInitialIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  reportActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  reportFilter: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  reportFilterActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired,
  username: PropTypes.string
};
ReportFilterPanel.defaultProps = {
  username: ''
};
export { ReportFilterPanel as TestReportFilterPanel };
export default entityComposition(ReportFilterPanel, ['reportFilter'], {
  reportIndexQuery: state => state.report.indexQuery,
  reportInitialIndexQuery: state => state.report.initialIndexQuery,
  assetFilterReportIndexQuery: state => state.assetFilterReport.indexQuery,
  assetFilterReportInitialIndexQuery: state => state.assetFilterReport.initialIndexQuery,
  issueSeverityFilterReportIndexQuery: state => state.issueSeverityFilterReport.indexQuery,
  issueSeverityFilterReportInitialIndexQuery: state => state.issueSeverityFilterReport.initialIndexQuery,
  jobAndPhaseCodeFilterReportIndexQuery: state => state.jobAndPhaseCodeFilterReport.indexQuery,
  jobAndPhaseCodeFilterReportInitialIndexQuery: state => state.jobAndPhaseCodeFilterReport.initialIndexQuery,
  jobPieceFilterReportIndexQuery: state => state.jobPieceFilterReport.indexQuery,
  jobPieceFilterReportInitialIndexQuery: state => state.jobPieceFilterReport.initialIndexQuery,
  reportAssignmentFilterReportIndexQuery: state => state.reportAssignment.indexQuery,
  reportAssignmentFilterReportInitialIndexQuery: state => state.reportAssignment.initialIndexQuery,
  currentStateFilterReportIndexQuery: state => state.currentState.indexQuery,
  currentStateFilterReportInitialIndexQuery: state => state.currentState.initialIndexQuery,
  orgFilterReportIndexQuery: state => state.orgFilterReport.indexQuery,
  orgFilterReportInitialIndexQuery: state => state.orgFilterReport.initialIndexQuery,
  reportTagFilterReportIndexQuery: state => state.reportTagFilterReport.indexQuery,
  reportTagFilterReportInitialIndexQuery: state => state.reportTagFilterReport.initialIndexQuery,
  reportTypeFilterReportIndexQuery: state => state.reportTypeFilterReport.indexQuery,
  reportTypeFilterReportInitialIndexQuery: state => state.reportTypeFilterReport.initialIndexQuery,
  statusFilterReportIndexQuery: state => state.statusFilterReport.indexQuery,
  statusFilterReportInitialIndexQuery: state => state.statusFilterReport.initialIndexQuery,
  creatorFilterReportIndexQuery: state => state.creatorFilterReport.indexQuery,
  creatorFilterReportInitialIndexQuery: state => state.creatorFilterReport.initialIndexQuery,
  userID: state => state.login.user.user_id,
  username: state => state.login.user.username
}, ['report', 'assetFilterReport', 'issueSeverityFilterReport', 'jobAndPhaseCodeFilterReport', 'jobPieceFilterReport', 'orgFilterReport', 'reportTagFilterReport', 'reportTypeFilterReport', 'statusFilterReport', 'reportAssignmentFilterReport', 'currentStateFilterReport', 'creatorFilterReport']);